var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3751",
    "data-name": "Rectangle 3751",
    width: 24,
    height: 24,
    transform: "translate(60 176)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4723",
    "data-name": "Mask Group 4723",
    transform: "translate(-60 -176)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7577",
    "data-name": "Group 7577",
    transform: "translate(63.445 181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7576",
    "data-name": "Group 7576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8182",
    "data-name": "Path 8182",
    d: "M17.108,8.008l-.01-.047c-.007-.031-.013-.061-.017-.089-.016-.112-.029-.227-.043-.338-.028-.233-.056-.475-.105-.711A8.553,8.553,0,0,0,.127,7.1c-.037.209-.063.421-.089.627-.012.1-.024.192-.037.287v1.05l0,.012c0,.016.007.033.01.049a.56.56,0,0,1,.014.077,8.4,8.4,0,0,0,.639,2.666,8.57,8.57,0,0,0,1.047,1.818.787.787,0,0,0,.636.334.8.8,0,0,0,.215-.03.787.787,0,0,0,.58-.694.923.923,0,0,0-.229-.645A6.866,6.866,0,0,1,1.656,7.538,6.613,6.613,0,0,1,3.323,3.951a6.788,6.788,0,0,1,5.2-2.36c.257,0,.523.013.79.038a6.485,6.485,0,0,1,3.842,1.694,6.853,6.853,0,0,1,2.225,6.658,6.59,6.59,0,0,1-1.249,2.767.791.791,0,0,0,.619,1.276.807.807,0,0,0,.647-.336,8.42,8.42,0,0,0,1.577-3.623c.04-.228.068-.46.1-.684.013-.1.025-.207.039-.311V8.021Z",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8183",
    "data-name": "Path 8183",
    d: "M191.9,143.913a.844.844,0,0,0-.243-.037.822.822,0,0,0-.591.269c-.3.3-.5.5-.7.7-.241.241-.469.469-.836.84-.03.03-.041.033-.042.033a.13.13,0,0,1-.047-.016,2.338,2.338,0,0,0-1-.229,2.433,2.433,0,1,0-.012,4.865h0a2.429,2.429,0,0,0,2.2-3.443c-.026-.057-.026-.057.019-.1.4-.392.542-.537.805-.8l.36-.36.125-.123c.1-.1.2-.2.3-.3a.8.8,0,0,0,.185-.757.771.771,0,0,0-.524-.534m-2.87,3.391a.85.85,0,0,1-.607,1.452h0a.853.853,0,0,1-.847-.855.867.867,0,0,1,.853-.853v0a.845.845,0,0,1,.6.255",
    transform: "translate(-179.871 -139.142)",
    fill: "#9e9e9e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon);
export default __webpack_public_path__ + "static/media/dashIcon.1fdb6030e77c40cce3ebcc7dd5942967.svg";
export { ForwardRef as ReactComponent };